import React, { useState } from 'react';
import { Translate } from '../../../config/TranslationProvider';

// The Tags component gets used multiple times on the same page, ensure our ids don't collide
let idCounter = 0;

export const Tags = ({register, tags, selected: userSelected, fixed, title = 'features', ariaLabel = 'tag'}) => {
    const [idPrefix] = useState(() => 'attribute-' + idCounter++ + '-');

    // The tag filter value can have a simple and an extended form
    const userSelectedResolved = Array.isArray(userSelected?.values) ? userSelected.values : userSelected;

    // Merge selected and fixed tags
    const selectedTags = new Set([...(userSelectedResolved || []) , ...(fixed || [])]);

    const additionalTags = new Set();
    for (const userTag of userSelectedResolved || []) {
        if (!tags.includes(userTag)) {
            additionalTags.add(userTag);
        }
    }

    return (
        <div className="filter-checklist">
            <h5><Translate value={title} /></h5>
            <div className="checklist-items feature-checklist">
                {tags.map((tag, key) => (
                    <div key={tag}
                        className="custom-control custom-checkbox checkbox-outline checkbox-outline-primary">
                        <input
                            type="checkbox"
                            className="custom-control-input"
                            id={idPrefix + key}
                            ref={register}
                            name={tag}
                            style={{zIndex: 500, width: '1.3333rem', height: '1.3333rem'}}
                            defaultChecked={selectedTags.has(tag)}
                            disabled={fixed && fixed.includes(tag)}
                            aria-label={ariaLabel}
                        />
                        <label className="custom-control-label" htmlFor={idPrefix + key}>
                            {tag}
                        </label>
                    </div>
                ))}

                {/* Keep additional tags */}
                {[...additionalTags].map((tag, index) => (
                    <input
                        key={tag}
                        type="hidden"
                        ref={register}
                        name={`additionalTags[${index}]`}
                        value={tag}
                    />
                ))}
            </div>
        </div>
    );
};

export default Tags;
